import { useInsertBeforeFinalScreen } from './useInsertBeforeFinalScreen';

export function useInsertImageUploadScreen(): () => void {
  const insertBeforeFinalScreen = useInsertBeforeFinalScreen();
  return () => {
    insertBeforeFinalScreen('image-upload');
  };
}
